import React, { useState } from "react";
import "./ProductTab.css";

const ProductTabs = () => {
  const [activeTab, setActiveTab] = useState("description");

  return (
    <div className="tabs-container">
      {/* Tabs */}
      <div className="tabs-header">
        <span
          className={activeTab === "description" ? "active" : ""}
          onClick={() => setActiveTab("description")}
        >
          Description
        </span>

        <span
          className={activeTab === "additional" ? "active" : ""}
          onClick={() => setActiveTab("additional")}
        >
          Additional Information
        </span>

        <span
          className={activeTab === "return exchange policy" ? "active" : ""}
          onClick={() => setActiveTab("return exchange policy")}
        >
          Return Exchange Policy
        </span>

        <span
          className={activeTab === "reviews" ? "active" : ""}
          onClick={() => setActiveTab("reviews")}
        >
          Reviews [5]
        </span>
      </div>

      {/* Content */}
      <div className="tabs-content">
        {activeTab === "description" && (
          <>
            <p>
              Crafted with precision and care, this saree showcases fine
              handwork by skilled artisans. The soft, breathable fabric ensures
              all-day comfort, while the elegant design enhances your overall
              look. A perfect choice for those who value quality, authenticity,
              and timeless style.
            </p>

            <p>
              Experience timeless elegance with this beautifully handcrafted
              saree, designed to make every moment special. Made from
              premium-quality fabric and detailed with intricate hand
              embroidery, it offers unmatched comfort and grace. Perfect for
              weddings, festive occasions, and celebrations, this saree is a
              blend of tradition and modern sophistication.
            </p>
          </>
        )}

        {activeTab === "additional" && (
          <p>Here you can add fabric, size, weight, and care details.</p>
        )}

        {activeTab === "return exchange policy" && (
          <p>Here you can add fabric, size, weight, and care details.</p>
        )}

        {activeTab === "reviews" && (
          <p>Customer reviews will be displayed here.</p>
        )}
      </div>
    </div>
  );
};

export default ProductTabs;
